import { get } from '../../utils/objectHelpers';

$ {
    const main = get(input, 'MAIN', []);
    const mainState = get(state, 'regionsData.MAIN', []);
    const header = main.find(e => e.meta && e.meta.name === 'STORE_INFORMATION');
    const tabsModule = main.find(e => e.meta && e.meta.name === 'STORE_TABS');
    const survey = main.find(e => e.meta && e.meta.name === 'SEEK_SURVEY_WEB');
    const sellerComms = main.find(e => e.meta && e.meta.name === 'SELLER_COMMS');
    const searchModule = mainState.find(e => e.meta && e.meta.name === 'SEARCH_STORE_V2');
    const controlbar = { tabsModule, searchModule };
}

<str-mini-header ...header />
<str-header ...header />
<str-controlbar ...controlbar />
<div class="app-layout app-layout--gutters">
    <str-tabpanels ...state.regionsData />
</div>
<str-survey ...survey />
<str-seller-comms ...sellerComms />
